import { LocationExitIcon } from './LocationExitIcon';

/**
 * author: Michael Richins
 * id 83A1C782-63D7-476B-8A6D-A694F29AE3A9
 * name location-exit
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/location-exit.svg
 * tags
 * - Home Automation 
 */
export const PresenceExitIcon = LocationExitIcon;
export default PresenceExitIcon